import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Maintenance from "./Maintenance";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/maintenance" element={<Maintenance />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
